export enum PROVIDERS {
  DATA_LAYER = 'data_layer',
}

export const ALL_PROVIDERS = [PROVIDERS.DATA_LAYER];
